import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import { toast } from "react-toastify";
import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput, SearchSubmitButton } from "../Form/Form";
import {
  addOneToDate,
  capitalizeFirstLetter,
  roundNumber,
} from "../../util/fn";
import { CSVLink } from "react-csv";
import { SendCreds } from "../../util/Svg";
import { API } from "../../constant/api";
import { ConfirmButton } from "../sweetalert";
import { requestHandler } from "../../services/requestHandler";
import moment from "moment";
import { updateLoading } from "../../store/auth/action";
import RefundPayment from "./RefundPayment";

const apiName = "payment-history/get-all";
const titleSingular = "Transaction";
const titlePlural = "Payment History";

const OBJ_TABLE = {
  "Order Number": "requestId",
  customer: `customer`,
  "Brand Name": "brandName",
  "Model Name": "modelName",
  vin: "vin",
  "Total Items": "sparePartsLength",
  "Txn Id": "txn_id",
  Amount: "amount",
  Status: "status",
  "Payment Gateway": "payment_gateway",
  "Refunded Amount": "refundedAmount",
  "Refund Reason": "refundReason",
  "Created On": "createdAt",
};

const dontShowSort = [];
const searchQueryHandler = (
  page,
  per_page,
  sortBy,
  order,
  isActive = "",
  requestId = "",
  customer = "",
  brandName = "",
  modelName = "",
  vin = "",
  dateFrom = "1970-01-01",
  dateTo
) => {
  if (sortBy.length > 0) {
    if (sortBy == "Model Name") {
      sortBy = "modelName";
    } else if (sortBy === "status") {
      sortBy = "status";
    } else if (sortBy === "Order Number") {
      sortBy = "requestId";
    } else if (sortBy === "Total Items") {
      sortBy = "sparePartsLength";
    } else if (sortBy === "Brand Name") {
      sortBy = "brandName";
    } else if (sortBy === "Created On") {
      sortBy = "createdAt";
    }
  }
  // else {
  //   sortBy = "createdAt";
  // }
  order = order.length > 0 ? order : "desc";

  dateFrom = dateFrom.length > 0 ? dateFrom : "1970-01-01";

  dateTo = dateTo ? addOneToDate(new Date(dateTo)) : addOneToDate(new Date());

  return `${apiName}?page=${page}&per_page=${per_page}&sortBy=${sortBy}&orderBy=${order}&isActive=${isActive}&requestId=${requestId}&customer=${customer}&brandName=${brandName}&modelName=${modelName}&vin=${vin}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
};

const ViewAll = () => {
  const dispatch = useDispatch();
  const [dataList, setDataList] = useState([]);
  const [allModels, setAllModels] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [perPage, setPerPage] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [currentSort, setCurrentSort] = useState({
    sortBy: "createdAt",
    order: "desc",
  });
  const [brands, setBrands] = useState([]);

  const { records_per_page } = useSelector((state) => state.setting);

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    clearErrors,
    setError,
    watch,
  } = useForm();

  const { request, response } = useRequest();

  const { request: requestModel, response: responseModel } = useRequest();
  // const { request: requestDelete, response: responseDelete } = useRequest();
  const { request: requestBrands, response: responseBrands } = useRequest();

  useEffect(() => {
    requestBrands("GET", "brand");
  }, []);

  useEffect(() => {
    if (responseBrands) {
      setBrands(responseBrands?.data);
    }
  }, [responseBrands]);

  useEffect(() => {
    const { brandName } = getValues();

    if (brandName != "" && brandName != undefined) {
      requestModel("GET", `brand-model/model/${brandName}`);
    }
  }, [watch("brandName")]);

  useEffect(() => {
    if (responseModel) {
      setAllModels(responseModel.modelData);
    }
  }, [responseModel]);

  useEffect(() => {
    if (records_per_page) {
      setPerPage(records_per_page);
      let {
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        dateFrom,
        dateTo,
      } = getValues();
      request(
        "GET",
        searchQueryHandler(
          page,
          records_per_page,
          currentSort.sortBy,
          currentSort.order,
          isActive,
          requestId,
          customer,
          brandName,
          modelName,
          vin,
          dateFrom,
          dateTo
        )
      );
    }
    document.title = `${titlePlural} - Easyspare`;
  }, [records_per_page]);

  useEffect(() => {
    if (response) {
      setDataList(response?.data);
      setTotalDocuments((prev) => response?.pagination?.totalCount ?? prev);
    }
  }, [response]);

  // useEffect(() => {
  //   if (responseDelete) {
  //     const { id } = responseDelete;
  //     let newDataList = [...dataList];
  //     newDataList = newDataList.filter((list) => list._id != id);
  //     setDataList(newDataList);
  //     toast.success(responseDelete.message);
  //   }
  // }, [responseDelete]);

  const fetchMoreData = ({ selected }) => {
    setDataList([]);
    const {
      isActive,
      requestId,
      customer,
      contact,
      email,
      brandName,
      modelName,
      vin,
      dateFrom,
      dateTo,
    } = getValues();

    setPage(selected + 1);
    request(
      "GET",
      searchQueryHandler(
        selected + 1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        dateFrom,
        dateTo
      )
    );
  };

  const onSearchHandler = (data) => {
    let {
      isActive,
      requestId,
      customer,
      brandName,
      modelName,
      vin,
      dateFrom,
      dateTo,
    } = getValues();

    if (brandName) {
      let filterData = brands.find((item) => item._id == brandName);

      brandName = filterData.name;
    }

    if (dateFrom && dateTo) {
      if (Moment(dateFrom).isAfter(dateTo)) {
        setError("dateTo", {
          type: "manual",
        });
        return;
      }
    }
    request(
      "GET",
      searchQueryHandler(
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        dateFrom,
        dateTo
      )
    );
    setPage(1);
  };

  const onResetHandler = (e) => {
    e.preventDefault();
    resetField("requestId");
    resetField("customer");
    resetField("brandName");
    resetField("modelName");
    resetField("vin");
    resetField("dateFrom");
    resetField("dateTo");
    setAllModels([]);
    request(
      "GET",
      searchQueryHandler(1, perPage, currentSort.sortBy, currentSort.order)
    );
    setPage(1);
  };

  const perPageChangeHandler = (event) => {
    const {
      isActive,
      customer,
      brandName,
      modelName,
      vin,
      contact,
      status,
      email,
      country,
      dateFrom,
      dateTo,
    } = getValues();

    request(
      "GET",
      searchQueryHandler(
        1,
        event.target.value,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        customer,
        brandName,
        modelName,
        vin,
        dateFrom,
        dateTo
      )
    );
    setPage(1);

    setPerPage(event.target.value);
  };

  const handleChangeBrand = () => {
    // let { brandName } = getValues();
    // console.log(brandName, "brandName");
  };

  const sortingHandler = (sortBy) => {
    const {
      isActive,
      customer,
      brandName,
      contact,
      modelName,
      email,
      vin,
      status,
      country,
      dateFrom,
      dateTo,
    } = getValues();

    if (currentSort.sortBy == sortBy) {
      const newOrder = currentSort.order === "asc" ? "desc" : "asc";
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          newOrder,
          isActive,
          customer,
          brandName,
          modelName,
          vin,
          dateFrom,
          dateTo
        )
      );
      setCurrentSort({ sortBy, order: newOrder });
    } else {
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          "desc",
          isActive,
          customer,
          brandName,
          modelName,
          vin,
          dateFrom,
          dateTo
        )
      );
      setCurrentSort({ sortBy, order: "desc" });
    }
  };

  const InputFields = [
    {
      label: "Order Number",
      name: "requestId",
      required: false,
    },
    {
      label: "Customer Name",
      name: "customer",
      required: false,
    },
    {
      isSelectInput: true,
      label: "Brand Name",
      name: "brandName",
      required: false,
      onChange: handleChangeBrand,
      children: (
        <>
          <option value="">{"Select an option"}</option>
          {brands?.length > 0 &&
            brands.map((item, index) => {
              return (
                <option value={item?._id} key={index}>
                  {item?.name}
                </option>
              );
            })}
        </>
      ),
    },
    {
      isSelectInput: true,
      label: "Model Name",
      name: "modelName",
      required: false,
      children: (
        <>
          <option value="">{"Select an option"}</option>
          {allModels?.length > 0 &&
            allModels.map((item, index) => {
              return (
                <option value={item?.name} key={index}>
                  {item?.name}
                </option>
              );
            })}
        </>
      ),
    },

    {
      label: "Vin",
      name: "vin",
      required: false,
    },

    {
      label: "Date From",
      name: "dateFrom",
      isDate: true,
      clearErrors,
    },
    {
      label: "Date To",
      name: "dateTo",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "'To Date' cannot be smaller than 'From Date'",
      },
    },
  ];
  const exportCsv = async () => {
    let { requestId, customer, brandName, modelName, vin, dateFrom, dateTo } =
      getValues();

    dispatch(updateLoading(true));
    let uri = `payment-history/export-csv?sortBy=${currentSort.sortBy}&orderBy=${currentSort.order}`;

    if (requestId) uri += `&requestId=${requestId}`;
    if (customer) uri += `&customer=${customer}`;
    if (brandName) {
      if (brandName) {
        let filterData = brands.find((item) => item._id == brandName);

        brandName = filterData.name;
      }
      uri += `&brandName=${brandName}`;
    }
    if (modelName) uri += `&modelName=${modelName}`;
    if (vin) uri += `&vin=${vin}`;
    if (dateFrom) uri += `&dateFrom=${dateFrom}`;
    if (dateTo) uri += `&dateTo=${dateTo}`;

    const response = await requestHandler(
      "GET",
      uri,
      {
        responseType: "blob", // Ensure response type is set to blob
      },
      dispatch
    );
    dispatch(updateLoading(false));

    if (!response) {
      return toast.error("Record not found.");
    }
    // Create a blob from the response data
    const blob = new Blob([response], { type: "text/csv" });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = `paymentHistory-${moment().toISOString()}.csv`; // Setting the filename
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up resources
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    let {
      isActive,
      requestId,
      customer,
      brandName,
      modelName,
      vin,
      status,
      dateFrom,
      dateTo,
    } = getValues();
    request(
      "GET",
      searchQueryHandler(
        page,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        isActive,
        requestId,
        customer,
        brandName,
        modelName,
        vin,
        dateFrom,
        dateTo
      )
    );
  };

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title={titlePlural}
        links={[{ to: "/", name: "Dashboard" }]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless">
                <div className="card-header">
                  <div className="card-title"></div>
                  <div className="card-toolbar">
                    <a
                      /*href="#!"*/
                      className="btn btn-primary dropdown-toggle mr-2"
                      data-toggle="collapse"
                      data-target="#collapseOne6"
                    >
                      Search
                    </a>
                    <div onClick={exportCsv} className="cursor-pointer">
                      <img
                        src="/csv.png"
                        width={45}
                        height={45}
                        title="Export CSV"
                      />
                    </div>
                    {/* {((roleId === 2 && !!permission["3_2"]) || roleId == 1) && (
                      <Link to="/orders/add" className="btn btn-primary">
                        Add New {titleSingular}
                      </Link>
                    )} */}
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="accordion accordion-solid accordion-toggle-plus"
                    id="accordionExample6"
                  >
                    <div
                      id="collapseOne6"
                      className="collapse"
                      data-parent="#accordionExample6"
                    >
                      <div>
                        <form
                          onSubmit={handleSubmit(onSearchHandler)}
                          className="kt-form kt-form--fit mb-0"
                        >
                          <div className="row mb-6">
                            {InputFields.map((inputMain, index) => (
                              <SearchInput
                                key={index}
                                {...inputMain}
                                errors={errors}
                                register={register}
                              />
                            ))}
                          </div>

                          <SearchSubmitButton
                            handleSubmit={handleSubmit}
                            onSearchHandler={onSearchHandler}
                            onResetHandler={onResetHandler}
                          />
                        </form>
                        <hr />
                      </div>
                    </div>
                  </div>

                  <div className="dataTables_wrapper ">
                    <Table
                      currentSort={currentSort}
                      sortingHandler={sortingHandler}
                      mainData={dataList}
                      tableHeading={Object.keys(OBJ_TABLE)}
                      tableData={Object.values(OBJ_TABLE)}
                      dontShowSort={dontShowSort}
                      renderAs={{
                        customer: (val, data, id) =>
                          id ? (
                            <div>
                              {/* {id ? id.customer  + "," + id.contact : "-"} */}
                              <span>{id.customer}</span>
                              <br /> <span>{id.email}</span>
                              <br /> <span>{id.contact}</span>
                            </div>
                          ) : (
                            ""
                          ),
                        amount: (val) => "SAR" + " " + roundNumber(val),
                        refundedAmount: (val) => "SAR" + " " + roundNumber(val),
                        refundReason: (val) => (val ? val : "-"),

                        status: (val) =>
                          val ? (
                            <span
                              style={{ height: "40px" }}
                              className={`label label-lg label-light-${
                                val === "Success"
                                  ? "success"
                                  : val === "Refund"
                                  ? "warning"
                                  : val === "Failed"
                                  ? "danger"
                                  : ""
                              } label-inline`}
                            >
                              {capitalizeFirstLetter(val || "")}
                            </span>
                          ) : (
                            ""
                          ),
                      }}
                      links={[
                        {
                          isLink: false,
                          name: "Refund",
                          click: (id, data) => {
                            setShowModal(true);
                            setModalData(data);
                          },
                          title: "Click To Refund",
                          key: "0_1",
                        },
                      ]}
                      onlyDate={{
                        createdAt: "dateTime",
                        startDate: "dateTime",
                        endDate: "dateTime",
                      }}
                    />

                    {perPage !== 0 && (
                      <Pagination
                        page={page}
                        totalDocuments={totalDocuments}
                        getNewData={fetchMoreData}
                        perPage={perPage}
                        defaultPerPage={records_per_page}
                        perPageChangeHandler={perPageChangeHandler}
                        currentDocLength={dataList?.length}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal ? (
        <RefundPayment
          setShowModal={handleCloseModal}
          showModal={showModal}
          TxnData={modalData}
        />
      ) : null}
    </div>
  );
};

export default ViewAll;
